/* global process */
import axios from 'axios'
import { Toast  } from 'vant'
// create an axios instance
const service = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: '/daily_business', // url = base url + request url
  timeout: 5000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    let token = localStorage.getItem('sushiWechatToken');
    if (token) {
        config.headers.common['token'] = token;
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    // if the custom code is not 0, it is judged as an error.
    if(res.code === 401){
      Toast('请登录后再操作');
      window.location.href = (process.env.VUE_APP_PUBLIC_PATH || '/') + '#/login';
      localStorage.setItem('sushiWechatToken','');
      localStorage.setItem('sushiWechatShopInfo','');
      return;
    }else if (res.code !== 0) {
      Toast(res.msg || '网络错误!');
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Toast(error.msg || '网络错误!');
    return Promise.reject(error)
  }
)

export default service
